import React from 'react';
import { Card, Typography, Button, Alert, Table, Tag, Space, Spin, Popconfirm, message } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import CampaignMessageModal from '../CampaignMessageModal';
import { getStatusColor, getStatusLabel } from '../../../utils/campaignUtils';
import { useMutation } from '@apollo/client';
import { DELETE_CAMPAIGN_MESSAGE } from '../../../graphql/mutations/deleteCampaignMessage';

const { Title } = Typography;

const MessagesStep = ({ 
  messageStatus, 
  handleFilterMessages,
  messagesLoading, 
  totalMessagesCount, 
  campaignMessages,
  handlePageChange,
  messagesPage,
  messagesPerPage,
  selectedMessage,
  messageDetailsVisible,
  handleViewMessageDetails,
  handleCloseMessageDetails,
  onMessageUpdated,
  onMessageDeleted
}) => {

  const [deleteCampaignMessage] = useMutation(DELETE_CAMPAIGN_MESSAGE, {
    onCompleted: (data) => {
      if (data.deleteCampaignMessage.success) {
        message.success('Mensagem excluída com sucesso!');
        if (onMessageDeleted) {
          onMessageDeleted();
        }
      } else {
        message.error(data.deleteCampaignMessage.errors[0] || 'Erro ao excluir mensagem');
      }
    },
    onError: (error) => {
      message.error('Erro ao excluir mensagem: ' + error.message);
    }
  });

  const handleDeleteMessage = (messageId) => {
    deleteCampaignMessage({
      variables: { id: messageId }
    });
  };

  return (
    <Card>
      <Title level={4}>Mensagens da Campanha</Title>
      <div style={{ marginBottom: 16 }}>
        <Space>
          <Button 
            type={messageStatus === "" ? "primary" : "default"} 
            onClick={() => handleFilterMessages("")}
            loading={messagesLoading && messageStatus === ""}
          >
            Todos
          </Button>
          <Button 
            type={messageStatus === "pending" ? "primary" : "default"} 
            onClick={() => handleFilterMessages("pending")}
            loading={messagesLoading && messageStatus === "pending"}
          >
            Pendentes
          </Button>
          <Button 
            type={messageStatus === "scheduled" ? "primary" : "default"} 
            onClick={() => handleFilterMessages("scheduled")}
            loading={messagesLoading && messageStatus === "scheduled"}
          >
            Agendados
          </Button>
        </Space>
      </div>
      
      <Alert
        message="Mensagens Geradas"
        description={`Foram geradas ${totalMessagesCount} mensagens personalizadas para esta campanha. ${
          messageStatus === "pending" ? "Mostrando apenas mensagens pendentes." : 
          messageStatus === "scheduled" ? "Mostrando apenas mensagens agendadas." : 
          "Mostrando todas as mensagens."
        }`}
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
      />
      
      <Spin spinning={messagesLoading}>
        <Table
          columns={[
            {
              title: 'Cliente',
              dataIndex: ['customer', 'name'],
              key: 'customerName',
            },
            {
              title: 'WhatsApp',
              dataIndex: ['customer', 'whatsapp'],
              key: 'whatsapp',
            },
            {
              title: 'Mensagem',
              dataIndex: 'message',
              key: 'message',
              ellipsis: true,
              width: '40%',
              render: (text) => text && text.length > 50 ? `${text.substring(0, 50)}...` : text,
            },
            {
              title: 'Status',
              dataIndex: 'status',
              key: 'status',
              render: (status) => (
                <Tag color={getStatusColor(status)}>
                  {getStatusLabel(status)}
                </Tag>
              ),
            },
            {
              title: 'Ações',
              key: 'actions',
              render: (_, record) => (
                <div>
                  <Button 
                    type="link" 
                    onClick={() => handleViewMessageDetails(record)}
                    style={{ display: 'block', marginBottom: 4 }}
                  >
                    Ver Detalhes
                  </Button>
                  {record.status === 'pending' && (
                    <Popconfirm
                      title="Tem certeza que deseja excluir esta mensagem?"
                      onConfirm={() => handleDeleteMessage(record.id)}
                      okText="Sim"
                      cancelText="Não"
                    >
                      <Button 
                        type="link" 
                        danger 
                        icon={<DeleteOutlined />}
                        style={{ display: 'block' }}
                      >
                        Excluir
                      </Button>
                    </Popconfirm>
                  )}
                </div>
              ),
            }
          ]}
          dataSource={campaignMessages}
          pagination={{
            current: messagesPage,
            pageSize: messagesPerPage,
            total: totalMessagesCount,
            onChange: handlePageChange
          }}
        />
      </Spin>
      
      {/* Use the shared campaign message modal component */}
      <CampaignMessageModal
        message={selectedMessage}
        visible={messageDetailsVisible}
        onClose={handleCloseMessageDetails}
        onMessageUpdated={onMessageUpdated}
      />
    </Card>
  );
};

export default MessagesStep; 